// extracted by mini-css-extract-plugin
export var container = "_st-0";
export var dotAnimation = "_st-2";
export var dotsLoading = "_st-1";